module.exports = __webpack_public_path__ + "assets/img/avalon.48e5fa76.svg";